export default __webpack_public_path__ + "static/media/femimed_aparat_usg_thumbnail.9165aa14.webp";